<template>
  <div class="row">
    <div class="thumbnail">
      <b-image :src="imageSrc" ratio="400by255" />
    </div>
    <div class="detail">
      <p class="date">配信開始：{{ startAt }}</p>
      <p class="title">{{ title }}</p>
      <b-button class="button" label="配信予定を確認/編集" @click="update" v-if="updateVisible"/>
    </div>
    <div class="status">
      <button type="button" class="button" @click="action" :disabled="disabled">
        <img class="icon" :src="buttonImage"/>
        {{buttonName}}
      </button>
    </div>
  </div>
</template>

<script>
import * as DateTime from '@/utils/date';

export default {
  name: 'LiveListedRow',
  props: {
    tileData: {
      type: Object,
      default() {
        return {
          liveId: '',
          imageSrc: '',
          nickname: '',
          startAt: '',
          title: '',
          type: ''
        };
      }
    },
    onClick: null
  },
  computed: {
    liveId() {
      return this.tileData.liveId;
    },
    link() {
      return this.tileData.link;
    },
    imageSrc() {
      return this.tileData.imageSrc;
    },
    nickname() {
      return this.tileData.nickname;
    },
    startAt() {
      return DateTime.formatJSDate('yyyy/MM/dd HH:mm', this.tileData.startAt);
    },
    buttonName() {
      return this.tileData.type == 'recent' ? '配信中' : '配信開始';
    },
    buttonImage() {
      return require('../../assets/image/btn_' + (this.tileData.type == 'recent' ? 'recent' : 'start_streaming') + (this.tileData.disabled ? '_disabled' : '') + '.png');
    },
    disabled() {
      return this.tileData.type == 'recent' ? false : this.tileData.disabled;
    },
    updateVisible() {
      return this.tileData.type != 'recent';
    },
    title() {
      return this.tileData.title;
    }
  },
  methods: {
    update() {
      this.$emit('update', this.tileData.liveId);
    },
    action() {
      this.$emit('action', this.tileData);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/live-listed-row.scss';
</style>
